import { apiSlice } from './apiSlice';


export const checkoutApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChallenges: builder.query({
      query: () => '/v3/challenges/',
      providesTags: ['Challenge'],
    }),

    /**
     * The visitor's country by IP — `{ country: "IN" }`. The live checkout
     * reads it for two rules: US clients start on cTrader, and aren't asked to
     * declare they are not a US person.
     */
    checkCountry: builder.query({
      query: () => '/check/country/',
    }),

    /**
     * `challengeId` is a path segment, the rest are query parameters, and
     * `undefined` ones are dropped by fetchBaseQuery — which is how the caller
     * omits `platform` on MT5 and `profit_split` on plans without the upgrade.
     */
    getFinalPrice: builder.query({
      query: ({ challengeId, ...params }) => ({
        url: `/v2/get/final-price/${challengeId}/`,
        params,
      }),
    }),

    previewAccount: builder.mutation({
      query: (body) => ({
        url: '/payment/account-preview/',
        method: 'POST',
        body,
      }),
    }),

    /** `body` is a `FormData` — fetchBaseQuery lets the browser set the boundary. */
    createPaymentUrl: builder.mutation({
      query: (body) => ({
        url: '/v2/get/checkout/payment-url/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useCheckCountryQuery,
  useGetChallengesQuery,
  useGetFinalPriceQuery,
  usePreviewAccountMutation,
  useCreatePaymentUrlMutation,
} = checkoutApi;
